import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';

import type { Id } from '../../types';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

type Variables = {
  debtorId: Id;
};

export async function refreshMonitoringFn(
  axiosInstance: Promise<AxiosInstance>,
  { debtorId }: { debtorId: Id },
) {
  const instance = await axiosInstance;
  return instance.post(`/debtors/${debtorId}/monitoring`);
}

export function useRefreshMonitoring() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, Variables>({
    mutationFn: variables => refreshMonitoringFn(axiosInstance, variables),
    onSuccess: (_response, { debtorId }) => {
      client.invalidateQueries({
        queryKey: ['monitoring', String(debtorId)],
      });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, Variables, 'refreshMonitoring'>(
    'refreshMonitoring',
    mutation,
  );
}
